import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Input, Button, InputGroup, InputGroupAddon } from 'reactstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { CONSENT_REQUESTS_FILTER } from "../../../reducers/consent/organizationConsents";
import { sharedLabelsPath } from "../../../reducers/common/localization";
import './ConsentRequestsFilter.css';
import IconContainer from './../../commonComponents/iconContainer/IconContainer';
import Select from 'react-select';

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        ":hover": {
            backgroundColor: state.isSelected ? '#89aa11' : 'rgba(137, 170, 17, 0.44)'
        },
        backgroundColor: state.isSelected ? '#89aa11' : 'white',
        cursor: 'pointer',
        width: '140px',
        fontSize: '.9rem',
        paddingTop: '0',
        paddingBottom: '0',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    }),
    control: (provided, state) => ({
        ...provided,
        fontSize: '.875rem',
        cursor: 'pointer',
        width: '140px',
        minHeight: 'calc(1.5em + .5rem + 2px)',
        height: 'calc(1.5em + .5rem + 2px)',
        border: '1px solid #ced4da',
        ":hover": {
            border: '1px solid #ced4da',
        },
        borderColor: state.isFocused ? '#80bdff' : '#ced4da',
        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: '0 5px 0 0'
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    menu: styles => ({
        ...styles,
        marginTop: '0',
        marginBottom: '0',
        borderRadius: '0'
    }),
    menuList: styles => ({
        ...styles,
        paddingTop: '0',
        paddingBottom: '0'
    })
};
class ConsentRequestsFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            job: ""
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.job !== nextProps.currentJob) {
            this.setState({ job: nextProps.currentJob || "" });
        }
    }

    render() {
        if (this.props.isVisible) {
            return (
                <div className="consent-requests-filter-container">
                    <div className="consent-requests-filter-status-container">
                        <h6>{_.get(this.props.translation, 'consents.status_filter_label') + ':'}</h6>
                        <Select
                            styles={customStyles}
                            options={this.getStatusOptions()}
                            value={{value: this.props.currentStatus, label: _.get(this.props.translation, 'consents.status.' + this.props.currentStatus)}}
                            onChange={this.handleChangeStatus}
                            isSearchable={false}/>
                    </div>
                    <div className="consent-requests-filter-job-container">
                        <h6>{_.get(this.props.translation, 'consents.job_title_label') + ':'}</h6>
                        <InputGroup size="sm">
                            <Input
                                bsSize="sm"
                                placeholder={_.get(this.props.translation, 'consents.job_filter_placeholder')}
                                value={this.state.job}
                                onChange={this.handleChangeJob}
                                onKeyPress={this.handleInputKeyPress}
                                onBlur={this.handleInputBlur}
                            />
                            <InputGroupAddon addonType="append" className="job-filter-clear-addon">
                                <Button
                                    onClick={this.setJobFilter}
                                    color="secondary"
                                    title={_.get(this.props.translation, sharedLabelsPath.search_label)}
                                    ref={(elem) => this.buttonSearchRef = elem}
                                >
                                    <IconContainer className="job-filter-search-icon" icon="search" />
                                </Button>
                            </InputGroupAddon>
                        </InputGroup>
                    </div>
                </div>
            )
        } else {
            return null;
        }
    }

    getStatusOptions() {
        return _.chain(CONSENT_REQUESTS_FILTER)
            .mapValues((value, key) => ({value: value, label: _.get(this.props.translation, 'consents.status.' + key)}))
            .values()
            .value();
    }

    handleChangeStatus = (selectedOption) => {
        this.props.onChangeStatus(selectedOption.value);
    };

    handleChangeJob = (e) => {
        this.setState({ job: e.target.value });
    };

    handleInputKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.setJobFilter();
        }
    };

    handleInputBlur = (e) => {
        let relatedTarget = e.relatedTarget;
        let searchButtonNode = ReactDOM.findDOMNode(this.buttonSearchRef);

        if (this.props.currentJob !== this.state.job && (relatedTarget !== searchButtonNode)) {
            this.setJobFilter();
        }
    };

    setJobFilter = () => {
        this.props.onChangeJob(this.state.job);
    };
}

ConsentRequestsFilter.propTypes = {
    isVisible: PropTypes.bool,
    currentStatus: PropTypes.string,
    currentJob: PropTypes.string,
    onChangeStatus: PropTypes.func.isRequired,
    onChangeJob: PropTypes.func.isRequired
};

export default ConsentRequestsFilter;



// WEBPACK FOOTER //
// ./src/components/organizationConsentManagement/consentRequestsFilter/ConsentRequestsFilter.js